import axios, { AxiosResponse } from 'axios';
import { makeApiUrl } from '../../../shared/util';
import { addAssociateMembershipWithdraw } from '../service';

export const getMembershipWithdrawAsLegacyStructureApi = async (
  membership_withdraw_id: number,
  crew_id: number,
) => {
  const { data } = await axios.get<
    string,
    AxiosResponse<Awaited<ReturnType<typeof addAssociateMembershipWithdraw>>>
  >(
    makeApiUrl('/@api/crews/:crew_id/membership_internal/membership_withdraws/:membership_withdraw_id', {
      membership_withdraw_id,
      crew_id,
    }),
  );
  return data;
};

export const cancelMembershipWithdrawApi = async (
  membership_withdraw_id: number,
  crew_id: number,
  body: object,
) => {
  const { data } = await axios.patch<string, AxiosResponse<{ a: 1 }>>(
    makeApiUrl(
      '/:lang/@api/crews/:crew_id/membership_internal/membership_withdraws/:membership_withdraw_id/cancel',
      {
        lang: T.lang,
        crew_id,
        membership_withdraw_id,
      },
    ),
    body,
  );
  return data;
};

export const approveMembershipWithdrawApi = async (
  membership_withdraw_id: number,
  crew_id: number,
  body: object,
) => {
  const { data } = await axios.patch<string, AxiosResponse<{ a: number }>>(
    makeApiUrl(
      '/:lang/@api/crews/:crew_id/membership_internal/membership_withdraws/:membership_withdraw_id/approve',
      {
        lang: T.lang,
        membership_withdraw_id,
        crew_id,
      },
    ),
    body,
  );
  return data;
};

export const changeMembershipWithdrawApi = async (
  membership_withdraw_id: number,
  crew_id: number,
  body: object,
) => {
  const { data } = await axios.patch<string, AxiosResponse<{ a: number }>>(
    makeApiUrl(
      '/:lang/@api/crews/:crew_id/membership_internal/membership_withdraws/:membership_withdraw_id/change',
      {
        lang: T.lang,
        crew_id,
        membership_withdraw_id,
      },
    ),
    body,
  );
  return data;
};
